//
// getters
//
import * as time from '@/libs/time'
import * as funcs from './funcs'

const deliNames = {
  0: 'なし',
  1: '出発のみ',
  2: '帰着のみ',
  3: '往復'
}

export default {
  // 予約可能期間
  bookAllow (state) {
    return {
      begin: time.make(state.allow.begin),
      end: time.make(state.allow.end)
    }
  },

  // 予約期間
  bookPeriod (state) {
    return {
      begin: time.make(state.period.begin),
      end: time.make(state.period.end),
      optdays: state.period.optdays,
      insurancedays: state.period.insurancedays
    }
  },

  // 予約車両
  bookCar (state, getters, rootState, rootGetters) {
    const carid = state.carid
    const cars = rootGetters['shop/m_cars'] || []
    return cars.find(item => item.id === carid)
  },

  // 料金
  bookCharge (state) {
    const basic = state.charge.basic
    const additional = state.charge.additional
    const discount = state.charge.discount
    const total = basic + additional - discount

    return {
      basic,
      additional,
      discount,
      total
    }
  },

  // 選択されたオプション一覧
  bookOptions (state, getters, rootState, rootGetters) {
    const optdays = state.period.optdays
    const options = rootGetters['shop/m_options']

    return options.reduce((opts, opt) => {
      const q = state.options[opt.id]
      if (!q) {
        return opts
      }

      const quantity = {
        value: 0,
        unit: ''
      }
      if (opt.max > 1 || opt.unit) {
        quantity.value = q
        quantity.unit = opt.unit
      } else {
        quantity.value = 1
      }

      opts.push({
        ...opt,
        quantity,
        charge: funcs.optionPrice(opt, optdays, q)
      })

      return opts
    }, [])
  },

  // 選択されたレンタルギア一覧
  bookGears (state, getters, rootState, rootGetters) {
    const optdays = state.period.optdays
    const options = rootGetters['shop/m_gears']

    return options.reduce((opts, opt) => {
      const q = state.gears[opt.id]
      if (!q) {
        return opts
      }

      const quantity = {
        value: 0,
        unit: ''
      }
      if (opt.max > 1 || opt.unit) {
        quantity.value = q
        quantity.unit = opt.unit
      }

      opts.push({
        ...opt,
        quantity,
        charge: funcs.optionPrice(opt, optdays, q)
      })

      return opts
    }, [])
  },

  // 免責補償
  bookInsurance (state, getters, rootState, rootGetters) {
    const insurancedays = state.period.insurancedays
    const insid = state.insuranceid
    const insurances = rootGetters['shop/m_insurances'] || []
    const ins = insurances.find(item => item.id === insid)
    if (!insid || !ins) {
      return {
        id: 0,
        name: 'なし',
        charge: 0
      }
    }
    return {
      id: ins.id,
      name: ins.name,
      charge: funcs.insurancePrice(ins, insurancedays)
    }
  },

  // 返却場所
  bookLocation (state, getters, rootState, rootGetters) {
    const locid = state.locationid
    const locations = rootGetters['shop/m_locations'] || []
    const loc = locations.find(item => item.id === locid)
    if (!locid || !loc) {
      return {
        id: 0,
        name: 'なし',
        charge: 0
      }
    }
    return {
      id: loc.id,
      name: loc.name,
      charge: loc.price
    }
  },

  // 送迎
  bookPick (state, getters, rootState, rootGetters) {
    const value = state.pick
    const pick = rootGetters['shop/m_pick']
    if (!value || !pick) {
      return null
    }
    return {
      value: value,
      name: deliNames[value],
      charge: funcs.deliPrice(pick, value)
    }
  },

  // 配車
  bookDeli (state, getters, rootState, rootGetters) {
    const value = state.deli
    const deli = rootGetters['shop/m_deli']
    if (!value || !deli) {
      return null
    }
    return {
      value: value,
      name: deliNames[value],
      charge: funcs.deliPrice(deli, value)
    }
  },

  // クーポン
  bookCoupons (state, getters, rootState, rootGetters) {
    const code = state.couponCode
    const coupons = rootGetters['shop/m_coupons'] || []
    if (!code || coupons.length === 0) {
      return []
    }

    const base = state.charge.basic
    const subtotal = state.charge.basic + state.charge.additional
    return coupons.reduce((cpns, cpn) => {
      if (cpn.condvalue !== code) {
        return cpns
      }

      let charge = 0
      switch (cpn.type) {
        case 0:
          // 円引き
          charge = cpn.value
          break
        case 1:
          // 基本料金 %引き
          charge = Math.floor(base * cpn.value / 100.0)
          break
        case 2:
          // 合計料金 %引き
          charge = Math.floor(subtotal * cpn.value / 100.0)
          break
      }

      cpns.push({
        ...cpn,
        charge
      })
      return cpns
    }, [])
  }
}
